import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function PricingCTA() {
  return <section id="pricing" className="py-14 px-4 md:px-6 relative bg-[#0d1326] border-y border-slate-800/50" data-id="element-138">
      <div className="absolute inset-0 bg-tech-pattern opacity-50" data-id="element-139"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-142">
            Hoy no pagarás{' '}
            <span className="line-through text-slate-500" data-id="element-143">$37 USD</span>.
          </h2>
          <p className="text-xl text-slate-300 mb-8" data-id="element-144">
            Estamos en lanzamiento y por tiempo limitado puedes acceder a este
            precio especial.
          </p>

          <div className="bg-slate-900/90 border border-cyan-500/50 rounded-3xl p-8 md:p-12 box-glow backdrop-blur-sm" data-id="element-145">
            <div className="uppercase tracking-widest text-cyan-400 font-bold text-sm mb-4" data-id="element-146">
              Oferta Especial de Lanzamiento
            </div>
            <div className="text-6xl md:text-7xl font-bold text-white mb-4 flex items-center justify-center gap-2" data-id="element-147">
              <span className="text-3xl text-cyan-400" data-id="element-148">$</span>6.99{' '}
              <span className="text-2xl text-slate-400 font-normal" data-id="element-149">USD</span>
            </div>
            <p className="text-slate-400 mb-8 italic" data-id="element-150">
              (Cuesta menos que un desayuno rápido… y te cambia la energía por
              completo).
            </p>

            <CTAButton text="SÍ, QUIERO EL PROTOCOLO POR $6.99" className="w-full py-5 text-xl" href="https://tucambiohoy.online/cart/43184160309361:1" data-id="element-151" />
          </div>
        </FadeIn>
      </div>
    </section>;
}